import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef } from 'react';
import NOB from '../../../../../constants/language-strings';
import { useForm } from '../../../../../utils/customHooks/use-form';
import { DeviceElement } from './device-element';
import { useProductActions } from 'modules/CustomerProducts/api';
import { ACTIVE } from 'constants/constant-strings';
import { Heading } from '../heading';
import styled from 'styled-components';
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import { purpurColorPurple800 } from '@purpurds/tokens/color/variables';
import spacing from 'theme/spacing';
const ChangeProductContainer = styled.div `
  width: 100%;
  line-height: 1.25;
  letter-spacing: 0.1px;
  margin-bottom: ${spacing.spacing32};
`;
const ChangeProductInput = styled.div `
  width: 100%;
`;
const StyledIcon = styled(Icon) `
  color: ${purpurColorPurple800};
  margin: 0 ${spacing.spacing4} ${spacing.spacing4} 0;
`;
export const ChangeProduct = ({ product, customerId, }) => {
    const productId = product.productId;
    const wasFetchingRef = useRef(false);
    const { activateWithSerials, clearActivationFieldError, resetActivationErrors, swapDeviceSerial, resetSwapDeviceSerial, errors, isProductFetching, } = useProductActions(customerId, productId);
    const shouldActivate = (device) => {
        return product.status !== ACTIVE || !device.serialNumber;
    };
    const onSubmit = (values) => {
        Object.entries(values)
            .filter(([, serial]) => Boolean(serial))
            .forEach(([dpadId, serial]) => {
            const device = product.devices.find(d => d.dpadId === Number(dpadId));
            if (!(device === null || device === void 0 ? void 0 : device.dpadId) || device.dpadId === 0) {
                console.error('Invalid device id', device);
                return;
            }
            const reload = product.devices.length <= 1;
            if (shouldActivate(device)) {
                activateWithSerials([
                    {
                        dpadId: device.dpadId,
                        serialNumbers: [serial],
                    },
                ]);
            }
            else {
                swapDeviceSerial(device.dpadId, serial, reload);
            }
        });
    };
    const { values, handleChange, handleSubmit, overrideValue } = useForm((currentValues) => onSubmit(currentValues));
    const activationFieldMap = errors.activationFieldMap;
    const deviceRows = useMemo(() => product.devices.map(device => {
        var _a;
        const fieldErrorMessage = activationFieldMap.get(device.dpadId) ||
            errors.swapDeviceSerial ||
            '';
        const serialNumberInput = {
            dpadId: device.dpadId,
            value: (_a = values[String(device.dpadId)]) !== null && _a !== void 0 ? _a : '',
            errorMessage: fieldErrorMessage,
        };
        const onReset = (dpadId) => {
            overrideValue(String(dpadId), '');
            resetSwapDeviceSerial();
            clearActivationFieldError(dpadId);
            resetActivationErrors();
        };
        const onScannerDetect = (result) => {
            var _a, _b;
            const code = (_b = (_a = result.codeResult) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : '';
            overrideValue(String(device.dpadId), code);
            if (!/^[A-Z0-9]*$/.test(code))
                return;
            const reload = product.devices.length <= 1;
            if (shouldActivate(device)) {
                activateWithSerials([
                    {
                        dpadId: device.dpadId,
                        serialNumbers: [code],
                    },
                ]);
            }
            else {
                swapDeviceSerial(device.dpadId, code, reload);
            }
        };
        return (_jsx(DeviceElement, { device: device, onReset: onReset, serialNumberInput: serialNumberInput, onScannerDetect: onScannerDetect, handleChange: handleChange, handleSubmit: handleSubmit, status: product.status, isFetching: isProductFetching }, device.dpadId));
    }), [
        product.devices,
        product.status,
        activationFieldMap,
        values,
        handleChange,
        handleSubmit,
        isProductFetching,
        swapDeviceSerial,
        overrideValue,
        errors.swapDeviceSerial,
        errors.activateWithSerials,
        activateWithSerials,
        clearActivationFieldError,
        resetActivationErrors,
        resetSwapDeviceSerial,
    ]);
    useEffect(() => {
        const hasAnyError = errors.activateWithSerials ||
            errors.swapDeviceSerial ||
            activationFieldMap.size > 0;
        if (wasFetchingRef.current && !isProductFetching && !hasAnyError) {
            Object.keys(values).forEach((key) => {
                if (values[key]) {
                    overrideValue(key, '');
                }
            });
        }
        wasFetchingRef.current = isProductFetching;
    }, [isProductFetching, errors, activationFieldMap]);
    return (_jsxs(ChangeProductContainer, { children: [_jsx(Heading, { icon: _jsx(StyledIcon, { svg: icons.sync, size: 'md' }), mainHeading: NOB.CHANGE_PRODUCT.SWAP_UNIT, subHeading: NOB.CHANGE_PRODUCT.ACTIVATE_UNIT }), _jsx(ChangeProductInput, { children: deviceRows })] }));
};
